window._ = require('lodash');

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.queryString = require('query-string');

import { DateTime, Interval, Settings } from "luxon";
Settings.defaultZoneName = "Europe/Brussels";
window.DateTime = DateTime;
window.DateTime.today = ()=>{
    return DateTime.now().startOf('day')
}

window.DateTime.dayPassed = (nbrDays, dateToCompareString)=>{
    let dateEnd=DateTime.fromFormat(dateToCompareString,'yyyy-LL-dd HH:mm:ss').startOf('day')
    let dateStart = DateTime.now().minus({days:nbrDays}).startOf('day')

    let diff = _.get(dateStart.diff(dateEnd).toObject(),'milliseconds');
    return diff >= 0;


    // let interval = Interval.fromDateTimes(dateEnd,)
    // console.log(interval)

}



window.Pusher = require('pusher-js');
